import { FetchAuth } from "../utils/FetchAuthUtil";

const endpoint = process.env.REACT_APP_API_ENDPOINT;

export class PublishersService {
    public static getPublishers = async ( archived: boolean, limit: number, page: number, searchTerm: string,sortColumn?:string|null,sortDirection?:string): Promise<any> => {
        try {
            const param = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                archived: archived.toString(),
                ...(searchTerm && { name: searchTerm })
            });
            if (sortColumn && sortDirection) {
                param.append('sort', `${sortColumn}:${sortDirection}`);
            }

            const resp = await FetchAuth(`${endpoint}/publisher/admin/getAllPublishers?${param.toString()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const data = await resp.json();
            return data;
        } catch (error) {
            throw error;
        }
    };

    public static getPublisherById = async (_id: string): Promise<any> => {
        try {
            const resp = await FetchAuth(`${endpoint}/publisher/getPublisher/${_id}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

          
            const data = await resp.json();
            return data;
        } catch (error) {
            throw error;
        }
    };

    // Create a new publisher
    public static createPublisher = async (publisher: FormData): Promise<any> => {
        try {
            const response = await FetchAuth(`${endpoint}/publisher/createPublisher`, {
                method: 'POST',
                body: publisher,  
            });

            const data = await response.json();
            return data;
        } catch (error) {
            throw error;
        }
    };

    // Update publisher details
    public static updatePublisher = async ( publisherData: FormData): Promise<any> => {
        try {
            const resp = await FetchAuth(`${endpoint}/publisher/editPublisher/${publisherData.get('uid')}`, {
                method: "PUT",
                body: publisherData, // Send FormData directly
            });
 
            const data = await resp.json();
            return data;
        } catch (error) {
             throw error;
        }
    };

    // Archive a publisher
    public static archivePublisher = async ( id: string): Promise<any> => {
        try {
            const resp = await FetchAuth(`${endpoint}/publisher/toggleArchive/${id}`, {
                method: "PATCH",
                headers: {
                    "Content-Type": "application/json",
                },
            });
 

            const data = await resp.json();
            return data.message;
        } catch (error) {
             throw error;
        }
    };

    // Delete a publisher
    public static deletePublisher = async ( id: string): Promise<any> => {
        try {
            const resp = await FetchAuth(`${endpoint}/publisher/deletePublisher/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

          

            const data = await resp.json();
            return data.message;
        } catch (error) {
             throw error;
        }
    };

    public static getFile = async ( format: "excel" | "csv" | "pdf"): Promise<Blob> => {
        try {
            const resp = await FetchAuth(`${endpoint}/admin/exportPublishers?format=${format}`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                },
            });

          

            const blob = await resp.blob();
            return blob;
        } catch (error) {
             throw error;
        }
    };

      public static getTopFile = async (format: "excel" | "csv",publisherId:string,year:string): Promise<Blob> => {
            try {
                const resp = await FetchAuth(`${endpoint}/admin/exportAnalyticsPublisher/analytics/publisher/${publisherId}/yearly/export?fileType=${format}&year=${year}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                });
    
             
    
                const blob = await resp.blob();
                return blob;
            } catch (error) {
                 throw error;
            }
    };

    public static getTopFileWebsite = async (format: "excel" | "csv",publisherId:string,year:string): Promise<Blob> => {
        try {
            const resp = await FetchAuth(`${endpoint}/admin/exportAnalyticsPublisherOnline/analytics/publisher/${publisherId}/yearly/export?fileType=${format}&year=${year}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

         

            const blob = await resp.blob();
            return blob;
        } catch (error) {
             throw error;
        }
    };
    public static getSalesByPublisherFile = async (format: "excel" | "csv", publisherId: string, year: string): Promise<Blob> => {
        try {
            let url;
            if(format === 'excel'){
                url = `${endpoint}/order/exportPublisherSalesExcel/${publisherId}/${year}`;
            } else if(format === 'csv'){
                url = `${endpoint}/order/exportPublisherSalesCSV/${publisherId}/${year}`;
            } else {
                throw new Error('Unsupported format');
            }
            const resp = await FetchAuth(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });
            const blob = await resp.blob();
            return blob;
        } catch (error) {
            throw error;
        }
    }
}
